import type { ComponentProps } from 'react';

import InfiniteProductGridDisplay from '../components/InfiniteProductGridDisplay';
import ProductDisplaySortType from '../components/ProductDisplaySortType';
import ProductDisplayHeaderTotalCount from '../components/ProductDisplayTotalCount';

type Props = {
  totalCount?: number;
  sortType?: 'SCORE' | 'DISPLAY_RANK' | 'LOW_PRICE' | 'LATEST_PRODUCTS';
} & ComponentProps<typeof InfiniteProductGridDisplay>;

const InfiniteProductDisplay = ({
  totalCount,
  data,
  sortType,
  ...rest
}: Props) => {
  return (
    <article className="pb-80">
      <div className="flex h-[46px] items-center justify-between px-20">
        {!!totalCount && (
          <ProductDisplayHeaderTotalCount totalCount={totalCount} />
        )}
        {sortType && <ProductDisplaySortType sortType={sortType} />}
      </div>

      <div className="px-20">
        <InfiniteProductGridDisplay
          {...rest}
          data={data}
          reverseCouponDiscountedPrice
        />
      </div>
    </article>
  );
};

export default InfiniteProductDisplay;
